















import Vue from 'vue'
import { api } from '@/singleton'
import mixins from 'vue-typed-mixins'
import easyapi from '@/easyapi'
import { presetDialogMixin } from '@/mixins'
import { Preset } from '@/types/api'

export default mixins(presetDialogMixin).extend({
  computed: {
    preset (): Preset | null { return this.dialog.preset }
  },
  methods: {
    async apply () {
      if (!this.preset) { return }
      const ok = await easyapi.deletePreset(this.preset)
      if (ok) {
        this.closeThisDialog()
      }
    }
  },
})
